/**
 * Where sign-in returns to (ADR-0070). `RequireAuth` sends a signed-out
 * visitor to `/login` with the page they asked for as `state.from`; after
 * sign-in they land there — a ticket link from an email opens the ticket —
 * and otherwise on Home.
 *
 * Only a path inside this app is accepted: it starts with one `/`, is not
 * protocol-relative (`//host`), carries no backslash (which some browsers read
 * as `/`), and is not the sign-in page itself. Anything else goes to Home, so
 * the return can never be pointed at another site.
 */

export const HOME = "/";

export function returnPath(state: unknown): string {
  const from =
    typeof state === "object" && state !== null && "from" in state
      ? String((state as { from: unknown }).from ?? "")
      : "";
  const inApp = from.startsWith("/") && !from.startsWith("//") && !from.includes("\\");
  if (!inApp || from === "/login" || from.startsWith("/login?") || from.startsWith("/login/")) {
    return HOME;
  }
  return from;
}
